import _ from 'lodash';
import alt from '../alt';
import {PageAction} from '../actions';
import {List} from 'immutable';
class UnWrappedPageStore {
  static config = {
    /**
     * Called when Alt receive a bootstrap
     * @param  {Object} data
     * @return {Object}      De-serialized data.
     */
    onDeserialize: (data) => {
      return data;
    },
  };

  /**
   * @constructor
   */
  constructor() {
    this.Config = {};
    this.Projects = {};
    this.Social_media = {};
    this.Contact = {};
    this.Profile = {};
    this.Team = {};
    this.Publications = {};
    this.Router = {};
    this.MenuOpen = new List([false]);
    this.bindActions(PageAction);
    this.exportPublicMethods({
      isMenuOpen: () => this.MenuOpen.first(),
    });
  }
  /**
   * Initialize the store with all the values
   * that our api give.
   * @param  {Object} storeSnapshot
   */
  onInit(storeSnapshot) {
    _.forEach(storeSnapshot, (value, key) => {
      this[key] = value;
    });
  }
  /**
   * Change the menu display.
   */
  onToggleMenu() {
    this.MenuOpen = this.MenuOpen.first()
      ? new List([false])
      : new List([true]);
    this.emitChange();
  }
}

export default alt.createStore(UnWrappedPageStore, 'PageStore');
